import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { ButtonReg } from 'atoms/Buttons';

export const TableWrapper = styled.div.attrs({
  className: 'col-12 px-0 mt-3'
})`
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  overflow-x: auto;
`

export const StyledTabBar = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-bottom: 1.5rem;
  margin-top: 0px;
`

export const BtnAddNew = styled(ButtonReg)`
  margin-right: 1.5rem;

  @media (max-width: 640px) {
    margin-right: .5rem;
  }
`

export const StyledTab = styled(NavLink)`
  width: 250px;
  height: 48px;
  color: ${({ theme }) => theme.mocaGrey};
  border-bottom: 1px solid ${({ theme }) => theme.mocaGrey};
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &.tab-link {
    width: 250px;
  }

  &.active {
    text-decoration: none;
    color: ${({ theme }) => theme.black};
    border-bottom: 6px solid ${({ theme }) => theme.mocaOrange};
    padding-top: 6px;
    font-weight: bold;
  }

  &:hover {
    color: ${({ theme }) => theme.black};
    background-color: ${({theme}) => theme.getRGBA(theme.blackAbs, 0.2000790550595238)};
    text-decoration: none;
  }
`

export const FilterRow = styled.div.attrs({
  className: 'col-12 mt-3 pb-3 px-0'
})`
  display: flex;
  flex-direction: row;
  align-items: flex-end;

  @media (max-width: 1424px) {
    flex-wrap: wrap;
    padding-top: 0 !important;
  }
`

export const RoundedWrapper = styled.div.attrs({
  className: 'col-12 mt-3'
})`
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  max-height: calc(100vh - 100px);
`


export const FilterCol = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 20px;

  @media (max-width: 1024px) {
    margin-right: 5px;
  }

  @media (max-width: 768px) {
    margin-right: 10px;
    margin-top: 10px;
  }
`

export const IframeWrapper = styled.div.attrs({
  className: 'mb-3'
})`
  max-height: calc(100vh - 300px);
  scroll-behavior: smooth;

  @media (max-width: 768px) {
    max-height: calc(100vh - 384px);
  }
`
